export const KickWhite = ({ width = '14', height = '12' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3851_23447)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0H5.03751V2.66667H6.71667V1.33333H8.39587V0H13.4334V4H11.7542V5.33332H10.075V6.66668H11.7542V8H13.4334V12H8.39587V10.6667H6.71667V9.33332H5.03751V12H0V0Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3851_23447">
          <rect width="14" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
